import React, {RefObject} from 'react'

type FileUploadProps = {
  multiple?: boolean;
  hidden?: boolean;
  toggle: boolean;
  accept?: string;
  changeHandler: (selectedFiles: Array<File>) => void;
}

/**
 * Generic file upload component which can handle selecting files for upload.
 * @param multiple Customize it to allow single or multiple files selection. Default: false.
 * @param hidden Make this component hidden. Default: true.
 * @param toggle Control the open/closed state of the file chooser component.
 * @param accept Control the acceptable file types which the file chooser should allow.
 * @param changeHandler Callback function which will be called with an array containing selected files.
 */
class FileUpload extends React.Component<FileUploadProps> {

  private readonly inputFileRef: RefObject<HTMLInputElement> = React.createRef();

  onChange = () => {
    if (this.inputFileRef.current) {
      // The component holds the files in a FileList which is an iterator. We copy the files
      // in a simple Array<File> which is more convenient for work.
      const currentFiles = this.inputFileRef.current.files || [];
      const selectedFiles: Array<File> = [];
      for (let i = 0; i < currentFiles.length; i++) {
        selectedFiles.push(currentFiles[i]);
      }
      // The field value needs to be cleared in order to allow selection of same file again.
      // Usually this would lead to duplications but we rely on the filtering in the handler up
      // in the parent.
      this.inputFileRef.current.value = '';
      this.props.changeHandler(selectedFiles);
    }
  };

  componentDidUpdate(prev: FileUploadProps) {
    if (prev.toggle !== this.props.toggle) {
      this.inputFileRef.current && this.inputFileRef.current.click();
    }
  }

  render() {
    return (
      <input id="inputFile" type="file" ref={this.inputFileRef} onChange={this.onChange}
             accept={this.props.accept || '*'}
             multiple={this.props.multiple || false}
             hidden={this.props.hidden || true}/>
    );
  }
}

export default FileUpload;
